import { useMemo } from 'react';
import { useLocation } from 'react-router';

export const useBasePath = (): string => {
  const { pathname } = useLocation();
  return useMemo(() => pathname.split('/')[1], [pathname]);
};
